import SharedNavbar from '../../components/feature/SharedNavbar';
import SharedFooter from '../../components/feature/SharedFooter';
import FloatingCallButton from '../../components/feature/FloatingCallButton';
import Hero from './components/Hero';
import Story from './components/Story';
import Values from './components/Values';
import Stats from './components/Stats';
import WhyChooseUs from './components/WhyChooseUs';
import Certifications from './components/Certifications';
import CTABanner from './components/CTABanner';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <Hero />
      <Story />
      <Values />
      <Stats />
      <WhyChooseUs />
      <Certifications />
      <CTABanner />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}